import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import '../index.css';
import '../shared/utils/apm';
import store from '../shared/store/redux';
import App from './app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));

const basename = process.env.REACT_APP_BASENAME || "/teacher";

root.render(
  <Provider store={store} >
    <BrowserRouter  basename={basename}>
      <App />
    </BrowserRouter >
  </Provider>
); 